import React from 'react'

const SearchIcon = ({ color = 'white', size = 22, opacity = 1 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ opacity }}
    >
      <path
        d="M10.3 17.2984C14.2764 17.2984 17.5 14.0749 17.5 10.0984C17.5 6.12199 14.2764 2.89844 10.3 2.89844C6.32353 2.89844 3.09998 6.12199 3.09998 10.0984C3.09998 14.0749 6.32353 17.2984 10.3 17.2984Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3 19.0986L15.385 15.1836"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SearchIcon
